import React, { useEffect, useRef, useState } from 'react';
import { graphql } from 'gatsby';
import parse from 'html-react-parser';
import './dataWrapper.scss';

interface Props {
  iframeCode: string;
}

const DataWrapper: React.FC<Props> = (props) => {
  useEffect(() => {
    /* This script listens for messages from the iframe and adjusts the height of the iframe accordingly. 
    The code is copied from Datawrapper's 'Responsive Iframe' script tag. Embedding the responsive iframe
    script directly or using Datawrapper's script embed doesn't work because there is no easy way to insert
    and execute a body script tag in React. */
    window.addEventListener('message', function (a) {
      if (void 0 !== a.data['datawrapper-height']) {
        var e = document.querySelectorAll('iframe');
        for (var t in a.data['datawrapper-height'])
          for (var r = 0; r < e.length; r++)
            if (e[r].contentWindow === a.source) {
              var i = a.data['datawrapper-height'][t] + 'px';
              e[r].style.height = i;
            }
      }
    });
  }, []);

  return <div className="datawrapper">{!!props.iframeCode && parse(props.iframeCode)}</div>;
};

export default DataWrapper;

export const query = graphql`
  fragment DataWrapperBlock on WpAcfDatawrapperBlock {
    AcfDatawrapper {
      iframeCode
    }
  }
`;
